<template>
    <div>
        <input type="text" name="call-num1" class="call-num1"
            :value="contact_array[0]" @input="setContact(0, $event.target.value)">
        <span class="call-br">-</span>
        <input type="text" name="call-num2" class="call-num2"
            :value="contact_array[1]" @input="setContact(1, $event.target.value)">
        <span class="call-br">-</span>
        <input type="text" name="call-num3" class="call-num3"
            :value="contact_array[2]" @input="setContact(2, $event.target.value)">
    </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import moment from 'moment-timezone'
  import { STATUS_CODE } from '@/lib/constants'

  import auth from '@/lib/auth_client'

  export default {

    name: 'contact-input',
    props: ['value'],
    // components: { Income, CashOut },
    data () {
      return {
        contact_array: []
      }
    },
    computed: {
    },
    methods: {
        setContact (idx, value) {
          this.contact_array[idx] = value
          let phone_string = this.contact_array.join('-')
          this.$emit('input', phone_string)
        }
    },
    watch: {
      value () {
        this.contact_array = (this.value) ? this.value.split('-') : Array(3)
      }
    },
    mounted () {
      this.contact_array = (this.value) ? this.value.split('-') : Array(3)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .call-num1, .call-num2, .call-num3 {width: 28%;}
    .call-br {margin: 0 10px;}
    .contact-test {width: 480px;}

    input {
        height: 50px;
        width: 80%;
        padding: 0 20px;
        border: 1px solid #d2d2d2;
        box-sizing: border-box;
        font: 400 16px 'Noto Sans KR', sans-serif;
    }
</style>
